/* eslint-disable */
import { useState, useEffect, memo, useRef } from "react";
import { Grid, GridColumn as Column, } from "@progress/kendo-react-grid";
import * as API from "../../framework/API/api";
import { COLUMNSTYPE, LOCALSTORAGE_KEY, MODULE, SOCKET_ACTION, SOCKET_EVENTS } from "../../framework/constant/constant";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { useTranslation } from "../../locale/useTranslation";
import RefreshButton from "../../framework/forms/helpercomponents/buttons/RefreshButton";
import moment from "moment";
import { toast } from "react-toastify";
import { DateCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import { LookupCell } from "../../framework/forms/helpercomponents/CustomGridCells/LookupCell";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import useSocket from "../../framework/socket/useSocket";
import { contractMediaEpisodeColumns } from "../../framework/utility/customColumns";
import PreferenceRoundButton from "../../framework/forms/helpercomponents/buttons/PreferenceRoundButton";
import { utility } from "../../framework/utility/utilityProvider";
import { UserPreference } from "../userPreference/UserPreference";

const PlanningContractMediaLibraryCollection = memo((props) => {

    const { channels, sort = { SID: 1 } } = props;
    const [columns, setColumns] = useState([]);
    // const columns = contractMediaEpisodeColumns;
    const [gridData, setGridData] = useState([]);
    const [gridDataToShow, setGridDataToShow] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [total, setTotal] = useState(1);
    const [showPreferences, setShowPreferences] = useState(false);
    const contextMenuRef = useRef(null);
    const selectedItemsRef = useRef([]);

    const setSelectedItemRef = (data) => {
        selectedItemsRef.current = data;
    }
    const initialSort = { field: 'SID', dir: "asc" }
    const [gridSort, setGridSort] = useState([initialSort]);
    const [page, setPage] = useState({
        skip: 0,
        take: 50,
    });
    const lang = useTranslation();

    useEffect(() => {
        if (channels.length > 0) {
            loaddata('', { per_page: page.take, current_page: 1, orderby: "SID", direction: "asc" });
        }
    }, [channels]);

    const socket = useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {
        if (socketData.module != MODULE.LIVE_EVENTS) return;
        switch (socketData.action) {
            case SOCKET_ACTION.LIVE_EVENT_REFRESH:
                loaddata('', []);
                break;
            default:
                break;
        }
    });

    const loaddata = async (searchText, pagination) => {
        try {
            setIsLoading(true);
            var currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
            var columnsRes = await API.getFormData('contractmedialibrary', currentUserId);
            let searchColumns = columnsRes.map(x => x.name);
            console.log(columnsRes)
            let json = await API.loadContractMediaLibrary(searchText, pagination, channels, searchColumns);
            setColumns(columnsRes);
            console.log(json);
            if (json.success) {
                setGridData(json.data ?? []);
                setGridDataToShow(json.data ?? [])
                setTotal(json.pagination.total);
                setIsLoading(false);
            } else {
                console.log(json.message);
                setIsLoading(false);
            }
        } catch (error) {
            console.log("error", error);
            setIsLoading(false);
        }
    }

    const onFilterSearchChange = (e) => {
        setSearchText(() => e.target.value);
        let sortEvent = gridSort[0] ?? initialSort;
        if (e.target.value == '') {
            loaddata('', { per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir });
        }
    };

    const onSearchClick = () => {
        let sortEvent = gridSort[0] ?? initialSort;
        if (searchText != '') {
            loaddata(searchText, { per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir });
        } else {
            loaddata('', { per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir });
        }
    }

    const onSearchEnter = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            onSearchClick();
        }
    }

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        await loaddata(searchText, { per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir });
        setPage(e.page);
    };

    const onSortChange = (e) => {
        setGridSort(e.sort)
        let sortEvent = e.sort[0] ?? sort;
        let current_page = page.skip / page.take + 1;
        loaddata(searchText, { per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir });
    }

    const onContextMenu = (e) => {
        e.syntheticEvent.preventDefault();
        contextMenuRef.current.show(e.syntheticEvent);
        console.log(e);
        setSelectedItemRef(e.dataItem);
    }

    const onRefresh = () => {
        let current_page = page.skip / page.take + 1;
        setSearchText("");
        loaddata('', { per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" });
    }

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} columns={columns} />
    );

    const onCloseUserPrefence = () => {
        let sortEvent = gridSort[0] ?? initialSort;
        loaddata(searchText, { per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir });
        setShowPreferences(!showPreferences);
    }

    return (
        <>
            <div style={{ height: "100%", width: "100%!important" }}>
                <h1 className="page-title" style={{ marginBottom: "-5px" }}>
                    <i
                        className="fa fa-table marlr"
                        style={{ fontSize: "20px", color: "GrayText" }}
                    ></i>
                    <span>{lang.contract_media_library_label}</span>
                </h1>

                <div className="flex-container pr-2 pl-2 mb-2">
                    <div className="flex-container-reverse flex-item-auto">
                        <PreferenceRoundButton onClick={() => { setShowPreferences(!showPreferences) }} />
                        <RefreshButton onClick={onRefresh} />
                    </div>
                </div>

                <div className="flex-container">
                    <div className="input-group input-group martb" >
                        <input
                            type="search"
                            className="form-control shadow-inset-2 pt-0 pb-0"
                            id="search"
                            value={searchText}
                            aria-label="type 2 or more letters"
                            placeholder={lang.search_button_text}
                            onKeyDown={onSearchEnter}
                            onChange={onFilterSearchChange}
                        />
                        <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                            <div className="input-group-append">
                                <span className="input-group-text">
                                    <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                </span>
                            </div>
                        </button>
                    </div>
                </div>
                {isLoading && <div className="ml-1">
                    <i style={{ fontSize: "20px", color: "GrayText" }} className="fas fa-spinner fa-pulse"></i>
                </div>}
                {!isLoading && <Grid
                    style={{ position: "absolute", left: 0, top: "180px", right: 0, bottom: 0 }}
                    data={gridDataToShow}
                    rowRender={props.MediaLibraryCollectionGridRowRender}
                    resizable={true}
                    pageable={true}
                    skip={page.skip}
                    take={page.take}
                    onPageChange={pageChange}
                    total={total}
                    onContextMenu={onContextMenu}
                    sort={gridSort}
                    sortable={true}
                    onSortChange={onSortChange}
                >
                    {/* Rows Loop */}
                    {columns.map((column, index) => {
                        if (column.type === COLUMNSTYPE.date) {
                            return (
                                <Column
                                    key={index}
                                    field={column.name}
                                    cell={DateCell}
                                    title={column.label}
                                    width={140}
                                    sortable={true}
                                />
                            );
                        } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                            return (
                                <Column
                                    key={index}
                                    field={column.name}
                                    cell={TimeCell}
                                    title={column.label}
                                    width={140}
                                    sortable={true}
                                />
                            );
                        } else if (column.name === "SID") {
                            return;
                        } else if (column.type === COLUMNSTYPE.image) {
                            return (
                                <Column
                                    key={index}
                                    field={column.name}
                                    cell={ImageCell}
                                    title={column.label}
                                    width={column.width ?? 200}
                                    sortable={false}
                                />
                            );
                        } else if (column.type === COLUMNSTYPE.select) {
                            return (
                                <Column
                                    key={index}
                                    field={column.name}
                                    cell={MyDatalookupCell}
                                    title={column.label}
                                    width={140}
                                    sortable={false}
                                />
                            );
                        }
                        else if (column.type === COLUMNSTYPE.array) {
                            return (
                                <Column
                                    key={index}
                                    field={column.name}
                                    cell={ArrayCell}
                                    title={column.label}
                                    width={140}
                                    format={column.format ?? "Description"} //display item in object
                                    sortable={false}
                                />
                            );
                        } else {
                            return (
                                column.type !== COLUMNSTYPE.hidden && (
                                    <Column
                                        key={index}
                                        field={column.name}
                                        title={column.label}
                                        width={140}
                                        sortable={true}
                                    />
                                )
                            );
                        }
                    })}
                </Grid>}

            </div>
            {showPreferences && <UserPreference entityName={'contractmedialibrary'} data={{}} setState={() => { }} handleClose={onCloseUserPrefence} />}
        </>
    );
});

export default PlanningContractMediaLibraryCollection;
